import startOfMonth from 'date-fns/start_of_month'
import subMonths from 'date-fns/sub_months'
import addDays from 'date-fns/add_days'
import addMonths from 'date-fns/add_months'
import eachDay from 'date-fns/each_day'
import endOfMonth from 'date-fns/end_of_month'
import getDaysInMonth from 'date-fns/get_days_in_month'
import areRangesOverlapping from 'date-fns/are_ranges_overlapping'
import isSameDay from 'date-fns/is_same_day'
import getISOWeek from 'date-fns/get_iso_week'
import startOfDay from 'date-fns/start_of_day'

const START_OF_WEEK_OFFSET = 1

/**
 *  Generate array of dates for month
 *
 * @export
 * @param {Number} month
 * @param {Number} year
 * @returns {Array} Array of dates
 */
export function getDaysArrayForMonth(month, year) {
    const monthStart = new Date(year, month, 1)
    const monthEnd = endOfMonth(monthStart)
    const day = monthStart.getDay()

    let days = []

    if (day > 0) {
        const prevMonthDays = getDaysInMonth(subMonths(monthStart, 1))
        for (let i = day - START_OF_WEEK_OFFSET; i >= 0; i--) {
            let d = startOfDay(new Date(
                monthStart.getFullYear(),
                monthStart.getMonth() - 1,
                prevMonthDays - i))
            days.push({
                date: d,
                active: d.getDay() !== 0 && d.getDay() !== 6
            })
        }
    }

    days = days.concat(
        eachDay(monthStart, monthEnd).map(date => ({
            date: date,
            active: date.getDay() !== 0 && date.getDay() !== 6
        }))
    )

    const nextMonth = startOfMonth(addMonths(monthStart, 1))
    const nextMonthStartDay = nextMonth.getDay()

    if (nextMonthStartDay !== 0) {
        for (let i = 0; i < 7 - nextMonthStartDay; i++) {
            let d = startOfDay(addDays(nextMonth, i))
            days.push({
                date: d,
                active: d.getDay() !== 0 && d.getDay() !== 6
            })
        }
    }

    return days
}

export function areDatesOverlapping(startDate, endDate, secondStartDate, secondEndDate) {
    return (
        isSameDay(startDate, secondEndDate) ||
        isSameDay(endDate, secondStartDate) ||
        areRangesOverlapping(startDate, endDate, secondStartDate, secondEndDate)
    )
}

/**
 * Split days array into weeks
 *
 * @export
 * @param {Array} daysArray
 * @returns {Array} Array of weeks
 */
export function splitDaysIntoWeeks(daysArray) {
    const arrays = []
    const size = 7

    while (daysArray.length > 0) {
        arrays.push({
            num: getISOWeek(daysArray[0].date),
            startDate: daysArray[0].date,
            endDate: daysArray[size - 1].date,
            days: daysArray.splice(0, size)
        })
    }

    return arrays
}